import Link from '@Components/common/Link';
import styled, { css } from 'styled-components';

export const Arrow = styled.div`
  max-width: 24px;
  min-width: 24px;
  max-height: 24px;
  min-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  transform: rotate(0deg) /*rtl: rotate(180deg) */;
  transition: 0.3s ease all;
`;

export const Icon = styled.div`
  max-width: 24px;
  min-width: 24px;
  max-height: 24px;
  min-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  margin-left: 0;
`;

export const Ul = styled.ul<{
  readonly open?: boolean;
}>`
  display: flex;
  flex-direction: column;
  height: auto;
  overflow: hidden;
  transition: 0.3s ease all;
`;

export const ListLink = styled(Link)<{
  readonly parent?: boolean;
  readonly active?: boolean | any;
}>`
  padding: 12px 22px 12px 42px;
  font-size: ${({ theme }) => theme.fontsizes.body14};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  transition: 0.3s ease all;
  border-bottom: 1px solid ${({ theme }) => theme.colors.counter};
  display: flex;
  align-items: center;
  &:hover {
    background-color: ${({ theme }) => theme.colors.cartBg};
  }
  ${({ parent }) =>
    parent
      ? css`
          padding: 12px 22px 12px 26px;
        `
      : css``}
  ${({ active }) =>
    active
      ? css`
          background-color: ${({ theme }) => theme.colors.cartBg};
        `
      : css``}
`;

export const ListHeader = styled.div<{
  readonly open?: boolean;
}>`
  display: flex;
  align-items: center;
  padding: 12px 22px 12px 26px;
  font-size: ${({ theme }) => theme.fontsizes.body14};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.black2};
  width: 100%;
  transition: 0.3s ease all;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.colors.counter};
  &:hover {
    background-color: ${({ theme }) => theme.colors.cartBg};
  }
  ${({ open }) =>
    open
      ? css`
          ${Arrow} {
            transform: rotate(90deg) /*rtl: rotate(90deg) */;
          }
        `
      : css``}
`;
